(function(){
  'use strict';
  var items=Array.isArray(window.ASM_SEARCH_INDEX)?window.ASM_SEARCH_INDEX:[];
  var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  function fold(value){return String(value||'').toLocaleLowerCase('az').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/ı/g,'i').replace(/ə/g,'e').replace(/[^a-z0-9]+/g,'')}
  function words(value){return String(value||'').toLocaleLowerCase('az').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/ı/g,'i').replace(/ə/g,'e').replace(/[^a-z0-9]+/g,' ').trim().split(/\s+/).filter(Boolean)}
  function withoutPrefix(value){return fold(value).replace(/^[a-z]+(?=\d)/,'')}
  function score(item,query){
    var q=fold(query),sku=fold(item.s),short=withoutPrefix(item.s),title=fold(item.t),type=fold(item.y),queryWords=words(query),titleWords=words(item.t),typeWords=words(item.y);
    if(!q)return -1;
    if(sku===q)return 1000;
    if(short===q)return 980;
    if(sku.startsWith(q))return 900-(sku.length-q.length);
    if(short.startsWith(q))return 880-(short.length-q.length);
    if(sku.includes(q))return 800-sku.indexOf(q);
    if(short.includes(q))return 780-short.indexOf(q);
    if(title===q)return 740;
    if(title.startsWith(q))return 720;
    if(title.includes(q))return 700-title.indexOf(q);
    if(queryWords.length>1){
      function hasWord(haystack,word){return haystack.some(function(candidate){return candidate===word||candidate.startsWith(word)||word.startsWith(candidate)})}
      var allInTitle=queryWords.every(function(word){return hasWord(titleWords,word)});
      if(allInTitle)return 660;
      var generic={qab:1,qabi:1,qablar:1,dest:1,desti:1,set:1,aksesuar:1,aksesuarlar:1,mehsul:1,mehsullar:1,alet:1,aletler:1};
      var concepts=queryWords.filter(function(word){return !generic[word]&&!generic[word.replace(/(?:i|si|lari|leri)$/,'')]});
      var allInType=queryWords.every(function(word){return hasWord(typeWords,word)});
      var conceptInTitle=concepts.length&&concepts.some(function(word){return hasWord(titleWords,word)});
      // A related result may come from its product family only when its title
      // still contains the main concept. This keeps semantic relatives while
      // preventing broad Shopify types from leaking unrelated products.
      if(allInType&&conceptInTitle)return 640;
      return -1;
    }
    if(title.includes(q))return 620-title.indexOf(q);
    if(type===q||type.startsWith(q))return 420;
    return -1;
  }
  function search(query,limit){
    return items.map(function(item){return {item:item,rank:score(item,query)}})
      .filter(function(x){return x.rank>=0})
      .sort(function(a,b){return b.rank-a.rank||a.item.s.localeCompare(b.item.s,'az')})
      .slice(0,limit||8).map(function(x){return x.item});
  }
  window.asmPremiumSearch={fold:fold,words:words,score:score,search:search};

  function enhance(input){
    if(!input||input.dataset.asmPremiumSearch)return;
    if(input.closest('.asm-quick-order'))return;
    var form=input.form;if(!form)return;
    input.dataset.asmPremiumSearch='1';input.setAttribute('autocomplete','off');
    var wrap=document.createElement('div');wrap.className='asm-search-suggestions';wrap.hidden=true;wrap.setAttribute('role','listbox');
    form.classList.add('asm-search-form');form.appendChild(wrap);
    function close(){wrap.hidden=true;wrap.replaceChildren();input.setAttribute('aria-expanded','false')}
    function open(){wrap.hidden=false;input.setAttribute('aria-expanded','true')}
    function render(){
      var q=input.value.trim();wrap.replaceChildren();if(!q){close();return}
      var hits=search(q,8);
      hits.forEach(function(p,i){
        var a=document.createElement('a');a.className='asm-search-suggestion';a.href=root+'products/'+encodeURIComponent(p.h);a.setAttribute('role','option');
        var img=document.createElement('span');img.className='asm-search-suggestion__image';if(p.i){var el=document.createElement('img');el.src=p.i;el.alt='';el.loading='lazy';img.appendChild(el)}
        var copy=document.createElement('span'),code=document.createElement('b'),title=document.createElement('span');code.textContent=p.s?'Kod: '+p.s:'Məhsul';title.textContent=p.t;copy.append(code,title);a.append(img,copy);wrap.appendChild(a);
      });
      if(!hits.length){var empty=document.createElement('p');empty.className='asm-search-suggestions__empty';empty.textContent='Uyğun məhsul tapılmadı.';wrap.appendChild(empty)}
      open();
    }
    var timer=0;input.addEventListener('input',function(){clearTimeout(timer);timer=setTimeout(render,45)});
    input.addEventListener('focus',function(){if(input.value.trim())render()});
    input.addEventListener('keydown',function(e){if(e.key==='Escape')close();if(e.key==='ArrowDown'&&!wrap.hidden){var first=wrap.querySelector('a');if(first){e.preventDefault();first.focus()}}});
    form.addEventListener('submit',function(e){var hits=search(input.value.trim(),2);if(hits.length&&score(hits[0],input.value)>=900){e.preventDefault();location.href=root+'products/'+encodeURIComponent(hits[0].h)}});
    document.addEventListener('pointerdown',function(e){if(!form.contains(e.target))close()});
  }
  var selector='.asm-desktop-search input[type="search"][name="q"],.asm-mobile-search input[type="search"][name="q"],.asm-touch-search input[type="search"][name="q"]';
  function ready(scope){
    scope=scope||document;
    if(scope.matches&&scope.matches(selector))enhance(scope);
    if(scope.querySelectorAll)scope.querySelectorAll(selector).forEach(enhance);
  }
  function start(){
    ready();
    new MutationObserver(function(records){records.forEach(function(record){record.addedNodes.forEach(function(node){if(node.nodeType===1)ready(node)})})}).observe(document.body,{childList:true,subtree:true});
  }
  document.addEventListener('shopify:section:load',function(event){ready(event.target)});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
